import ozToggle from '@/components/oz-toggle'
import { DATAZAP_STAMPS } from '@/utils/constants/filters'

export default {
  name: 'oz-toggle-datazap',

  props: {
    stamps: { type: Array, default: () => [] },
    business: { type: String, required: true },
    isPill: { type: Boolean },
  },

  computed: {
    initialValue () {
      this.stamps = Array.isArray(this.stamps) ? this.stamps : []
      return !!this.stamps.filter((i) => Object.values(DATAZAP_STAMPS).includes(i)).length
    },
  },

  methods: {
    updateDatazap (value) {
      this.$emit('filters:update', { stamps: value ? [DATAZAP_STAMPS[this.business]] : [] }, 'stamps')
    },
  },

  components: {
    ozToggle,
  },
}
